import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { FaSearch, FaUsers } from "react-icons/fa";
import { Alerts, GetUser } from "../../../helpers";
import '../../../assets/css/layout.css'
import MUIDataTable from "mui-datatables";
import ThemeModal from "../../../components/cmp/ThemeModal";
import { Formik, ErrorMessage, Form } from "formik";
import 'react-phone-number-input/style.css'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import OtpInput from 'react-otp-input';
import { Spinner } from "react-bootstrap";
import OtpTimer from "../../../components/OTP/OtpTimer";
import CSVImportForm from "../../../components/CSVImportForm";
import CreateUserForm from "../../../components/users/CreateUserForm";
import { FaEye, FaFileImport, FaFileExport, FaPlus   } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Checkbox } from '@mui/material';
import { GrPowerReset } from "react-icons/gr";
// const options = {
//   filter: false,
//   download: false,
//   print: true,
//   selectableRows: false
// };

const User = () => {
  const [isLoading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [isNew, setNew] = useState(false);
  const [verificationEmail, setVericationEmail] = useState('')
  const [isOtp, setOtp] = useState(false);
  const [isExpired, setExpired] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [isImport, setImport] = useState(false);


  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchText, setSearchText] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const [selectedIds, setSelectedIds] = useState([]);

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [userStatus, setuserStatus] = useState('');

  const handleOtpExpired = () => {
    setExpired(true);
  };

  const fetchUser = async () => {
    console.log({userStatus: userStatus})
    let resp = await GetUser.getAllUser({
        page: page + 1,
        limit: rowsPerPage,
        search: searchText || '',
        startDate: startDate || undefined,
        endDate: endDate || undefined,
        userStatus: userStatus,
      });

    if (resp && resp.status) {
      setLoading(false);
      setUsers(resp.users);
      setTotalCount(resp.totalUsers || 0);
    } else {
        setUsers([]);
        setTotalCount(0);
      }
  };

  useEffect(() => {
    fetchUser();
  }, [page, rowsPerPage, searchText, startDate, endDate, userStatus]);


    const handleRowSelect = (id) => {
    setSelectedIds(prev =>
      prev.includes(id)
        ? prev.filter(itemId => itemId !== id)
        : [...prev, id]
    );
  };


  const handleSelectAll = () => {
    const userIdList = users.map(item => item.id);
     if (selectedIds.length === userIdList.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(userIdList);
    }
  };
  
  const options = {
    serverSide: true,
    count: totalCount,
    page: page,
    rowsPerPage: rowsPerPage,
    filter: false,
    search: false,
    download: false,
    print: false,
    selectableRows: 'none',
    rowsSelected: selectedIds
      .map(id => users.findIndex(item => item.id === id))
      .filter(index => index !== -1),
    onTableChange: (action, tableState) => {
      if (action === 'changePage') {
        setPage(tableState.page);
      } else if (action === 'changeRowsPerPage') {
        setRowsPerPage(tableState.rowsPerPage);
        setPage(0);
      }
    },
  };


    const CustomHeaderCheckbox = () => (
      <Checkbox
        onChange={handleSelectAll}
        checked={selectedIds.length === users.length && users.length > 0}
        indeterminate={selectedIds.length > 0 && selectedIds.length < users.length}
      />
    );
  
    const CustomRowCheckbox = ({ rowIndex }) => {
      const id = users[rowIndex]?.id;
      return (
        <Checkbox
          checked={selectedIds.includes(id)}
          onChange={() => handleRowSelect(id)}
        />
      );
    };


  const columns = [
      {
      name: 'SL',
      options: {
        customHeadRender: () => <div style={{ marginLeft: 10 }}><CustomHeaderCheckbox /></div>,
        customBodyRender: (value, tableMeta) => (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <CustomRowCheckbox rowIndex={tableMeta.rowIndex} />
            <span style={{ marginLeft: 8 }}>{value}</span>
          </div>
        ),
      }
    },
    {
      name: 'Name',
      sortable: true,
    },
    {
      name: 'Email',
      sortable: true,
    },
    {
      name: 'Address',
      sortable: true,
    },
    {
      name: 'Orders',
      sortable: true,
    },
    {
      name: 'Total Spend',
      sortable: true,
    },
    {
      name: 'Status',
      sortable: true,
    },
    {
      name: 'Actions',
      sortable: false,
    },
  ];

  const getTotalSpent = (orders) => {
    let totalSpent = 0.00;
    if (orders.length > 0) {
      orders.forEach(order => {
        totalSpent = parseFloat(totalSpent) + parseFloat(order.total_amount);
      });
    }
    return totalSpent.toFixed(2);
  }
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    const resp = await GetUser.addNewUser(values);
    if (resp && resp.status) {
      setVericationEmail(resp.email);
      setOtp(true);
      setSubmitting(false);
      resetForm();
      fetchUser();
    } else {
      setSubmitting(false);
    }
  }
  const verifyOtp = async (values, { setSubmitting, resetForm }) => {
    values.email = verificationEmail;
    const resp = await GetUser.verifyNewUser(values);
    if (resp && resp.status) {
      Alerts.alertMessage(resp.message, 'top-right', 'success');
      setSubmitting(false);
      resetForm();
      setOtp(false);
      setNew(false);
      setVericationEmail('');
    } else {
      setSubmitting(false);
    }
  }

  const skipAndCountineu = () => {
    setOtp(false);
    setNew(false);
    setVericationEmail('');
    Alerts.alertMessage('Customer added successfully without verification', 'top-right', 'success');
  }


  const resentOtp = async (email) => {
    setResendLoading(true);
    let resp = await GetUser.resentOtp({ email: email });
    if (resp) {
      setResendLoading(false);
      setExpired(false);
    }
  }


  const handleExport = async () => {
    try {
      setDownloadLoading(true);
      const resp = await GetUser.exportUsers();

      if (resp) {
        const url = window.URL.createObjectURL(new Blob([resp]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'users_export.csv');
        document.body.appendChild(link);
        link.click();
        link.remove();
        setDownloadLoading(false);
      }

    } catch (err) {
      console.error('Download failed:', err);
    }
  };


  const handleResetFilters = () => {
    setStartDate('');
    setEndDate('');
    setSearchInput('');
    setSearchText('');
    setPage(0);
    setuserStatus('')
  };
  const handleSearch = () => {
    setPage(0);
    setSearchText(searchInput.trim());
  };

  return (
    <>
      <div className="innerPageWrapper">
        <Container fluid="md">
          <div className='page-title'>
            <h2><FaUsers />Users</h2>
            <div className='media-actions'>
              <button className="btn btn-default btn-sm d-flex align-items-center gap-1" onClick={() => setImport(true)}><FaFileImport style={{fontSize:14}}/> Import</button>
              <button className="btn btn-primary btn-sm d-flex align-items-center gap-1 text-white" onClick={handleExport} disabled={downloadLoading}><FaFileExport style={{fontSize:14}} /> {downloadLoading ? 'Please wait' : 'Export'}</button>
              <button className="btn btn-success btn-sm d-flex align-items-center gap-1" onClick={() => setNew(true)}><FaPlus style={{fontSize:14}} /> Add User</button>
            </div>
          </div>
      <div className="order-filter mb-3 d-flex gap-3 align-items-center flex-wrap justify-content-between">
         <div className="d-flex gap-3 align-items-center flex-wrap">
        <div>
          <label>Start Date</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="form-control"
          />
        </div>
        <div>
          <label>End Date</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
             className="form-control"
          />
        </div>
        <div>
          <label>Status</label>
         
          <select
            value={userStatus}
            onChange={(e) => setuserStatus(parseInt(e.target.value))}
             className="form-control"
          >
            <option value="">Status</option>
            <option value="1">Active</option>
            <option value="0">Unactive</option>
          </select>
        </div>
       
        <button className="btn btn-secondary" onClick={handleResetFilters}>
         <GrPowerReset/> Reset Filters
        </button>
         </div>
         <div className="searchInput">
          <div class="input-group">
            <input type="text" 
             value={searchInput}
             onChange={(e) => setSearchInput(e.target.value)}
             class="form-control" 
             placeholder="Search by name or email" />
             <button class="btn btn-outline-secondary" type="button" onClick={handleSearch}><FaSearch/></button>
         </div>
         </div>
    
    
       
       
      
      </div>
          {isLoading && users && users.length > 0 ? "Data Loading..." : <MUIDataTable className="hideHeader"
            title={`All Users (${users.length})`}
            data={users.map((item, i) => {
              return [
                ++i,
                item.name,
                item.email,
                `${item.address !== null ? item.address : ''} ${item.address_line_2 !== null ? `, ${item.address_line_2}` : ''} ${item.address_line_3 !== null ? `, ${item.address_line_3}` : ''}`,
                `${item.orders.length} ${item.orders.length > 1 ? 'Orders' : 'Order'}`,
                <div className="text-right">£{getTotalSpent(item.orders)}</div>,
                <div className={`badge ${item.is_active ? "bg-success" : "bg-danger" }`}>
                      {item.is_active  ? 'Active' :'Unactive'}
                </div>,
                <div className={`actions`}>
                  <Link to={`/app/users/${item.id}`} className="btn btn-info btn-sm"><FaEye size={14} /></Link> &nbsp;
                </div>
              ]
            })}
            columns={columns}
            options={options}
          />
          }

          {isImport && <ThemeModal show={isImport} handleHide={() => setImport(false)} title={'Import New Users'} isHeader={true}>

            <CSVImportForm setImport={setImport} fetchUser={fetchUser} />

          </ThemeModal>}
          <ThemeModal show={isNew} handleHide={() => setNew(false)} title={'Add New User'} isHeader={true} size="lg">
            {
              isOtp ? <div style={{ maxWidth: 300, margin: '25px auto' }}>
                <Formik
                  initialValues={{ otp: "" }}
                  validate={(values) => {
                    const errors = {};
                    if (!values.otp) {
                      errors.otp = "OTP is required !";
                    } else if (values.otp.length !== 6) {
                      errors.otp = "OTP should be 6 digit.";
                    } else if (isNaN(values.otp)) {
                      errors.otp = "OTP should be digits.";
                    }
                    return errors;
                  }}
                  onSubmit={verifyOtp}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue

                  }) => (
                    <form onSubmit={handleSubmit}>
                      <h5 style={{ textAlign: 'center' }}>Verify with OTP</h5>
                      <p style={{ textAlign: 'center', marginBottom: 15, fontSize: 14 }}>Sent to : {verificationEmail} </p>
                      <OtpInput
                        value={values.otp}
                        onChange={(otp) => setFieldValue('otp', otp)}
                        numInputs={6}
                        renderSeparator={<span>-</span>}
                        renderInput={(props) => <input {...props} />}
                        containerStyle={{ justifyContent: 'space-between' }}
                        inputStyle={{
                          width: '40px',
                          height: '40px',
                          fontSize: '18px',
                          borderRadius: '4px',
                          border: '1px solid #ccc',
                        }}
                      />
                      {errors.otp && touched.otp && (
                        <div style={{ textAlign: 'center' }}>
                          <span className="helpError">{errors.otp}</span>
                        </div>

                      )}
                      {
                        resendLoading ? <div style={{ textAlign: 'center', marginTop: 10 }}><Spinner animation="border" variant="dark" size="sm" /> Please wait.. </div> : <>
                          <div style={{ textAlign: 'center', marginBottom: 15, marginTop: 10 }}>
                            {!isExpired ? <OtpTimer duration={10} onExpire={handleOtpExpired} /> : <div className={'resendOtp'}>
                              <p>If you didn't receive OTP :</p> <button type="button" onClick={() => resentOtp(verificationEmail)} >Resend</button>
                            </div>}
                          </div>

                          <div style={{ margin: '0px auto 15px', display: "flex", alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                            <button className="t_primary_btn t_full_width " type="submit" disabled={isLoading} style={{ maxWidth: 100 }}>
                              {isLoading ? <><Spinner animation="border" variant="light" size="sm" /> Please wait.. </> : 'Continue'}
                            </button>
                            <button className="btn btn-default " type="button" disabled={isLoading} onClick={skipAndCountineu}>
                              Skip & Continue
                            </button>
                          </div>
                        </>
                      }


                    </form>
                  )}
                </Formik>
              </div> :
                <CreateUserForm handleSubmit={handleSubmit} />

            }
          </ThemeModal>
        </Container>
      </div>
    </>
  );
};

export default User;
